import React from "react";
import "../App.css";

function Notice() {
  return (
    <div id="notice-text">
      <p>!!!!!   NOTICE   !!!!!!</p>
      <p>This Is A Food Ordering WebSITe UI , With Some Added Features.</p>
      <p>This is A Sample UI , For Representational Purpose.</p>
      <p>This Website Is Made With REACT JS.</p>
      <p>It's A Responsive Website (For 2 - view ports).</p>
      <p>Some Features Are Not Working (Displaying Purpose Only) ,  Sorry For That.</p>
      <p>Thanks For Visiting My Project WebSite. </p>
      <p>Designed And Created By -</p>
      <p>Mr Tushar Ranjan Mallick</p>
    </div>
  );
}
export default Notice;
